// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  THOUGHT_JOURNAL_SET_FILTERED,
} from './constants';

export function setFiltered(value) {
  return {
    type: THOUGHT_JOURNAL_SET_FILTERED,
    data: value
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case THOUGHT_JOURNAL_SET_FILTERED:
      return {
        ...state,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/thought-journal/redux/setFiltered.js